import EditTaxRate from "../../components/organisms/softpos/EditTaxRate"
import { AdminTemplate } from "../../components";

export const EditTaxRatePage = () => {

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Vergi Oranı Düzenleme",
        hideAddButton: true,
      }}
    >
      <EditTaxRate />
    </AdminTemplate>
  );
};
